import { Component, OnInit, Output } from '@angular/core';
import { UserService } from '../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service/auth.service.component';
import { Observable } from 'rxjs';
import { EventEmitter } from 'protractor';
import { userInfo } from 'os';
import { User } from './user';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  private controller: string = "Security";
  user: User = new User ();
  isLoginError : boolean = false;
  invalidCredentialMsg: string;
  username:string;
  password:string;
  retUrl:string="login";

  constructor(private userService : UserService, private authService: AuthService,
              private router : Router, private toastr: ToastrService,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.activatedRoute.queryParamMap
            .subscribe(params => {
        this.retUrl = params.get('retUrl'); 
        console.log( 'UserComponent/ngOnInit '+ this.retUrl);
    });
  }

  loginSubmit(userName: string, userPassword: string)
  {
    if(this.user.userName == "admin" && this.user.userPassword == "admin")
    {
    this.router.navigate(['/articles']);
    }
    else
    {
      this.toastr.error("بيانات دخول غير صحيحة. يرجى المحاولة مرة أخرى");
    }
    //this.authService.login(this.user.userName, this.user.userPassword).subscribe(data => {
    };
  

  logout()
  {
    this.authService.logout();
  }

  onFormSubmit(loginForm) {
    this.authService.login(loginForm.value.username, loginForm.value.password).subscribe(data => {
      console.log(loginForm.value.username, loginForm.value.password);
      console.log( 'return to '+ this.retUrl);
      if (loginForm.value.username == "admin" && loginForm.value.password == "admin") {
        this.router.navigate(['/articles']);
      }
      else if (loginForm.value.username == "fees" && loginForm.value.password == "fees") {
        const currentUser = loginForm.value.username;
        this.authService.isUserLoggedIn.name == "fees";
        this.router.navigate(['/fee-payments']);
        console.log(currentUser);
      }
      else if (loginForm.value.username == "students" && loginForm.value.password == "students") {
        this.authService.isUserLoggedIn.name == "students";
        console.log(this.authService.isUserLoggedIn.name);
        this.router.navigate(['/students']);
      }
      else if (loginForm.value.username == "cert" && loginForm.value.password == "cert") {
        this.authService.isUserLoggedIn.name == "cert";
        console.log(this.authService.isUserLoggedIn.name);
        this.router.navigate(['/students']);
      }
      else {
      this.toastr.error('خطأ فى إسم المستخدم أو كلمة المرور', ' تسجيل غير مسموح !!');
      // this.router.navigate( ['/dashboard']);
    }
    });
  }

  OnSubmit(userName,password){
    // this.userService.userAuthentication(userName,password).subscribe((data : any)=>
    if (userName == "admin" && password == "fees")
    {
     // localStorage.setItem('userToken',data.access_token);
      this.router.navigate(['/fee-payments']);
    } 
    else{
      this.toastr.error('خطأ فى إسم المستخدم أو كلمة المرور', ' تسجيل غير مسموح !!');
    }
    (err : HttpErrorResponse)=>{
      this.isLoginError = true;
    };
  }
}
